import { wrappedApiClient } from '@/hooks/useAxios';

const ApiPath = '/pdf';

/**
 * Export to PDF with automatic cancellation support
 * Wrap this call with useApiRequest in components to enable cancellation:
 *
 * @example
 * const { execute: exportPDF, cancel } = useApiRequest(
 *   () => exportToPDF(url, filename),
 *   { requestKey: 'pdf-export' }
 * );
 *
 * @param url - URL to export
 * @param filename - Optional filename for the PDF
 * @returns PDF Blob
 */
export const exportToPDF = async (
  url: string,
  filename?: string,
): Promise<Blob> => {
  const params = new URLSearchParams({ url });
  if (filename) {
    params.append('filename', filename);
  }

  // Use wrappedApiClient.getRaw to support RequestContext and AbortController
  return await wrappedApiClient.getRaw<Blob>(
    `${ApiPath}/export?${params.toString()}`,
    {
      responseType: 'blob',
      headers: {
        Accept: 'application/pdf',
      },
    }
  );
};
